import React from "react"
import logo from "../../images/logo.png"

import { Container } from "./styled"

const About = props => {

  return (
    <>
      <Container>
        <section className="text-white body-font">
          <div className="container mx-auto flex  items-center justify-center flex-col">
          <img src={logo} />
            <div className="text-center lg:w-2/3 w-full">
              <p className="mb-8 leading-relaxed">
              No escritório Faustino e Vieira, oferecemos defesa especializada em Direito Criminal. Nossa equipe de advogados experientes está comprometida em proteger seus direitos e garantir uma representação eficaz. Entre em contato para uma consulta e veja como podemos ajudar no seu caso.
              </p>
            </div>
          </div>
        </section>
      </Container>
    </>
  )
}

export default About
